<!--  -->
<template>
  <div class="frame">
    <titleBox
      :title="$t('message.development.title')"
      :desc="$t('message.development.subTitle')"
    ></titleBox>

    <div class="content">
      <div :class="{ list: true, jp: lang == 'jp' }">
        <div class="item">
          <div class="icon">
            <img src="../assets/develop1.png" alt="" />
          </div>
          <div class="title">{{ $t("message.development.type1.title") }}</div>
          <div class="desc">
            <p>{{ $t("message.development.type1.desc1") }}</p>
            <p>{{ $t("message.development.type1.desc2") }}</p>
            <p>{{ $t("message.development.type1.desc3") }}</p>
            <p>{{ $t("message.development.type1.desc4") }}</p>
          </div>
          <div class="btn" @click="toContact">
            {{ $t("message.development.btnText") }}
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <img src="../assets/develop2.png" alt="" />
          </div>
          <div class="title">{{ $t("message.development.type2.title") }}</div>
          <div class="desc">
            <p>{{ $t("message.development.type2.desc1") }}</p>
            <p>{{ $t("message.development.type2.desc2") }}</p>
            <p>{{ $t("message.development.type2.desc3") }}</p>
          </div>
          <div class="btn" @click="toContact">
            {{ $t("message.development.btnText") }}
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <img src="../assets/develop3.png" alt="" />
          </div>
          <div class="title">{{ $t("message.development.type3.title") }}</div>
          <div class="desc">
            <p>{{ $t("message.development.type3.desc1") }}</p>
            <p>{{ $t("message.development.type3.desc2") }}</p>
            <p>{{ $t("message.development.type3.desc3") }}</p>
            <p>{{ $t("message.development.type3.desc4") }}</p>
          </div>
          <div class="btn" @click="toContact">
            {{ $t("message.development.btnText") }}
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <img src="../assets/develop4.png" alt="" />
          </div>
          <div class="title">{{ $t("message.development.type4.title") }}</div>
          <div class="desc">
            <p>{{ $t("message.development.type4.desc1") }}</p>
            <p>{{ $t("message.development.type4.desc2") }}</p>
            <p>{{ $t("message.development.type4.desc3") }}</p>
          </div>
          <div class="btn" @click="toContact">
            {{ $t("message.development.btnText") }}
          </div>
        </div>
        <div class="item">
          <div class="icon">
            <img src="../assets/develop5.png" alt="" />
          </div>
          <div class="title">{{ $t("message.development.type5.title") }}</div>
          <div class="desc">
            <p>{{ $t("message.development.type5.desc1") }}</p>
            <p>{{ $t("message.development.type5.desc2") }}</p>
            <p>{{ $t("message.development.type5.desc3") }}</p>
            <p>{{ $t("message.development.type5.desc4") }}</p>
          </div>
          <div class="btn" @click="toContact">
            {{ $t("message.development.btnText") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: localStorage.getItem("lang"),
    };
  },
  created() {},
  mounted() {},
  methods: {
    toContact() {
      this.$router.push("/contact");
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  width: 1200px;
  margin: 45px auto 60px;
  font-size: 14px;

  .list {
    padding: 0 25px 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    .item {
      width: 220px;
      height: 280px;
      padding: 0 8px 20px;
      box-sizing: border-box;
      background-color: #fff;
      border-top: 8px solid #01b3b2;
      margin-top: 50px;
      position: relative;
      text-align: center;

      .icon {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        text-align: center;
        line-height: 110px;
        background-color: $theme;
        position: absolute;
        left: 50%;
        top: -55px;
        transform: translateX(-50%);

        img {
          width: 40px;
        }
      }
      .title {
        font-weight: bold;
        margin-top: 60px;
        font-size: 20px;
        color: rgb(31, 135, 232);
      }
      .desc {
        height: 90px;
        font-size: 14px;
        line-height: 1.8;
        margin-top: 20px;
        color: #666;
      }
      .btn {
        width: 110px;
        height: 30px;
        line-height: 30px;
        border: 1px solid $theme;
        color: $theme;
        font-size: 14px;
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          background-color: $theme;
          color: #fff;
        }
      }
    }
  }

  .jp .item {
    height: 345px;
    .btn {
      width: 120px;
    }
  }
}
</style>